import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HTML from 'react-native-render-html';
import { openURL } from '../_helpers';

import { Dimensions } from 'react-native';

class WebView extends Component {
  render() {
    const { content } = this.props;

    if (!content) {
      return null;
    }

    return <HTML
      onLinkPress={(event, url) => {
        openURL(url);
      }}
      html={content}
      imagesMaxWidth={Dimensions.get('window').width}
    />;
  }
}

WebView.propTypes = {
  content: PropTypes.any
};

export default WebView;
